


export const baseUrl = `https://safe-courier-rest-api.onrender.com/parcels`













    
  


    